// ZEO-Autopilot (03.11.2026): reine Anzeige-Logik fuer Befunde im Freigabe-Eingang (Aufgabendetail + Filter „Autopilot-Befunde“).
// Keine Aktionen hier: Entscheidungen zeigen nur die Vorschau des bestehenden Weges (Backend: ausgefuehrt=false).
export const EINSTUFUNG = {
  ungeklaert: { label: 'Ungeklärt', ton: 'rot' },
  dringend_frist: { label: 'Dringend (Frist)', ton: 'rot' },
  erledigung_moeglich: { label: 'Erledigung möglich – Nachweis fehlt', ton: 'gelb' },
  erledigt: { label: 'Erledigung belegt', ton: 'gruen' },
  redundant: { label: 'Dublette (belegt)', ton: 'gruen' },
  weiter: { label: 'Weiter bearbeiten', ton: 'blau' },
};

export const ENTSCHEIDUNG = {
  ergebnis_uebernehmen: 'Ergebnis übernehmen',
  entwurf_bearbeiten: 'Entwurf bearbeiten',
  erledigen_mit_nachweis: 'Mit Nachweis erledigen',
  zusammenfuehrung_pruefen: 'Zusammenführung prüfen',
  vorgang_zuordnen: 'Vorgang zuordnen',
  rueckfrage_beantworten: 'Rückfrage beantworten',
  zurueckstellen: 'Zurückstellen',
};
export const ALLE_ENTSCHEIDUNGEN = Object.keys(ENTSCHEIDUNG);

const STATUS = { offen: 'Offen', in_bearbeitung: 'In Bearbeitung', wartend: 'Wartend', erledigt: 'Erledigt', abgebrochen: 'Abgebrochen' };
const SPERRE = {
  sperrliste: 'Historische Fehlzuordnung – für die Automatik gesperrt',
  posteingang_zuordnung_pruefen: 'Mail-Zuordnung im Posteingang ungeklärt',
  klientenkonflikt: 'Quelle gehört einem anderen Klienten – nicht gelesen',
};

export function datum(iso) {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(iso || ''));
  return m ? `${m[3]}.${m[2]}.${m[1]}` : '—';
}

// Welche Entscheidungen der Befund sinnvoll anbietet -- die empfohlene zuerst, Zurueckstellen immer.
export function angeboteneEntscheidungen(b) {
  if (!b) return [];
  const a = new Set([b.empfehlung]);
  if (b.einstufung !== 'ungeklaert') {
    if (['versandprotokoll', 'frist_erledigt'].includes(b.erledigung?.art) || b.redundanz?.abdeckend) a.add('erledigen_mit_nachweis');
    if ((b.zusammenfuehrung_kandidaten || []).length) a.add('zusammenfuehrung_pruefen');
    if (b.vorgang_vorschlag) a.add('vorgang_zuordnen');
    if (b.arbeitsergebnis?.art === 'briefentwurf') { a.add('entwurf_bearbeiten'); if (b.arbeitsergebnis.empfaenger_belegt) a.add('ergebnis_uebernehmen'); }
  }
  a.add('rueckfrage_beantworten'); a.add('zurueckstellen');
  return [...a].filter((x) => ENTSCHEIDUNG[x]);
}

export function erledigungText(b) {
  if (b?.erledigung?.art === 'versandprotokoll') return `Nachweis: Versandprotokoll vom ${datum(b.erledigung.datum)} (Schreiben zu dieser Aufgabe versendet)`;
  if (b?.erledigung?.art === 'frist_erledigt') return 'Nachweis: zugehörige Frist im Fristenmodul als erledigt markiert';
  if (b?.erledigung_hinweis) return `Nur Hinweis, kein Nachweis: ${b.erledigung_hinweis.hinweis}`;
  return 'Keine belegte Erledigung';
}

export function dublettenText(b) {
  if (b?.redundanz?.abdeckend) return `Belegt: ${b.redundanz.nachweis}`;
  const n = (b?.zusammenfuehrung_kandidaten || []).length;
  if (n) return `${n} offene Aufgabe(n) zur gleichen Sache aus derselben Quelle – Zusammenführung prüfen (nicht automatisch)`;
  return 'Keine Dublette belegt';
}

export function standText(b) {
  const a = b?.aufgabe || {};
  const v = b?.verlauf || {};
  const s = b?.schreiben || {};
  const teile = [STATUS[a.status || b?.status] || a.status || b?.status || '—'];
  if (v.eintraege !== undefined) teile.push(`${v.eintraege} Verlaufseinträge (${v.menschlich || 0} manuell)`);
  if (s.briefe) teile.push(`${s.briefe} Schreiben, ${(s.versendet || []).length} versendet`);
  return teile.join(' · ');
}

export function quellenText(b) {
  const q = (b?.quellen || []).map((x) => `${x.art === 'frist' ? 'Frist' : 'Dokument'} ${datum(x.datum)}${x.kategorie ? ` (${x.kategorie})` : ''}`);
  const g = (b?.gesperrt || []).length;
  return (q.length ? q.join(', ') : 'keine eigenen Quellen') + (g ? ` · ${g} gesperrt (anderer Klient, nicht gelesen)` : '');
}

// Die neun Pflichtangaben je Befund (Reihenfolge = Anzeige).
export function befundZeilen(b) {
  if (!b) return [];
  const a = b.aufgabe || {};
  const z = [
    ['Aufgabe', a.titel || b.aufgabe_id],
    ['Klient', a.klient_name || b.klient_id || '—'],
    ['Bearbeitungsstand', standText(b)],
    ['Einstufung', (EINSTUFUNG[b.einstufung] || { label: b.einstufung }).label],
    ['Frist / Priorität', `${b.frist ? datum(b.frist) : 'keine Frist'} · Priorität ${a.prioritaet || b.prioritaet || '—'}`],
    ['Geprüfte Quellen', `${(b.geprueft || []).join(', ') || '—'} – ${quellenText(b)}`],
    ['Mögliche Erledigung', erledigungText(b)],
    ['Mögliche Dublette', dublettenText(b)],
    ['Nachweis für Erledigung', b.nachweis_regel?.text || '—'],
    ['Fehlende Informationen', (b.fehlende_angaben || []).join(' · ') || '—'],
    ['Begründung', (b.gruende || []).join(' · ') || '—'],
    ['Unsicherheiten', (b.unsicherheiten || []).join(' · ') || '—'],
    ['Erforderliche Entscheidung', ENTSCHEIDUNG[b.empfehlung] || b.empfehlung || '—'],
  ];
  if ((b.sperre || []).length) z.unshift(['Gesperrt', b.sperre.map((s) => SPERRE[s] || s).join(' · ')]);
  if (b.veraltet) z.unshift(['Hinweis', 'Aufgabe seit der Analyse verändert – Befund veraltet, bitte neu prüfen']);
  return z;
}

export function vorschauText(v) {
  if (!v) return '';
  if (!v.ok) return `Nicht möglich: ${v.grund}`;
  return `Würde ausführen: ${v.methode} ${v.endpunkt}${v.folgeschritt ? ` → danach ${v.folgeschritt}` : ''}${v.hinweis ? ` (${v.hinweis})` : ''} – noch NICHT ausgeführt`;
}

// 04.11.2026: KI-Standanalyse (Qwen/Mittwald) -- nur Vorschlag, nie Nachweis. Zitate sind gegen den Dokumenttext geprueft.
export const KI_STATUS = {
  offen: 'Offen', teilweise: 'Teilweise bearbeitet', erledigt_laut_unterlagen: 'Laut Unterlagen möglicherweise erledigt (kein Nachweis)', unklar: 'Unklar',
};
export function kiBelegText(x) {
  return `Dokument vom ${datum(x.datum)} (${String(x.dokument_id || '').slice(0, 8)})${x.zitat ? `: „${x.zitat}“` : ''}${x.aussage ? ` – ${x.aussage}` : ''}`;
}

// 04.11.2026: Nachtautopilot -- Morgen-Uebersicht
export const NACHT_KATEGORIE = {
  dringend: 'Dringend', rueckfrage: 'Rückfrage erforderlich', vorbereitet: 'Vorbereitet', nicht_bearbeitet: 'Nicht bearbeitet',
};
const NACHT_GRUND = {
  limit_max_aufgaben: 'Nachtlimit erreicht', zeitfenster_ende: 'Zeitfenster zu Ende', qwen_budget: 'KI-Budget der Nacht verbraucht',
  stop: 'Lauf angehalten', sperre_verloren: 'Lauf-Sperre verloren', aufgabe_nicht_mehr_vorhanden: 'Aufgabe nicht mehr vorhanden',
};
export function nachtGrund(g) {
  if (!g) return '';
  return g.startsWith('fehler:') ? `Prüfung fehlgeschlagen (${g.slice(7)})` : (NACHT_GRUND[g] || g);
}
export function nachtKopf(l) {
  if (!l) return 'Noch kein Nachtlauf.';
  const z = l.zaehlung || {};
  const st = { fertig: 'abgeschlossen', unvollstaendig: 'nicht vollständig', abgebrochen: 'abgebrochen', unterbrochen: 'unterbrochen', laeuft: 'läuft' }[l.status] || l.status;
  return `Nachtlauf ${datum(l.start)} ${String(l.start || '').slice(11, 16)}–${String(l.ende || '').slice(11, 16) || '…'} UTC: ${st}`
    + `${l.abbruch_grund ? ` (${nachtGrund(l.abbruch_grund)})` : ''} · ${z.gesamt ?? 0} offene Aufgaben erfasst (${z.ueberfaellig ?? 0} überfällig, `
    + `${z.faellig_48h ?? 0} in 48 h fällig, ${z.ohne_frist ?? 0} ohne Frist; ${z.gesperrt ?? 0} gesperrt) · KI-Aufrufe ${l.qwen_verbraucht ?? 0}`;
}
